import * as React from "react";
import { alpha } from "@mui/material/styles";
// import { makeStyles } from '@mui/material/styles';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
import { visuallyHidden } from "@mui/utils";
import SeatsContext from "../store/seats/seats-context";
import SaveIcon from "@mui/icons-material/Save";

import date from "date-and-time";
import useHttp from "../hooks/use-http";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertColor, AlertProps } from "@mui/material/Alert";
import { LoadingButton } from "@mui/lab";

import Dialog from "@mui/material/Dialog";
import Avatar from "@mui/material/Avatar";

import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";


const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={3} ref={ref} variant="filled" {...props} />;
});

interface Data {
  //   SNo: string;
  UserID: string;
  UserDirectory: string;
  Products: string;
  AddedOn: string;
  LastAccess: string;
  Status: number;
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

type Order = "asc" | "desc";

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

interface HeadCell {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
}

const headCells: readonly HeadCell[] = [
  //   {
  //     id: "SNo",
  //     numeric: false,
  //     disablePadding: true,
  //     label: "SNo",
  //   },
  {
    id: "UserID",
    numeric: false,
    disablePadding: false,
    label: "User ID",
    
  },
  {
    id: "UserDirectory",
    numeric: false,
    disablePadding: false,
    label: "User Directory",
  },
  {
    id: "Products",
    numeric: false,
    disablePadding: false,
    label: "Products",
  },
  {
    id: "AddedOn",
    numeric: false,
    disablePadding: false,
    label: "Added On",
  },
  {
    id: "LastAccess",
    numeric: false,
    disablePadding: false,
    label: "Last Access",
  },
  {
    id: "Status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
];

interface EnhancedTableProps {
  numSelected: number;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler =
    (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {/* <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all desserts",
            }}
          />
        </TableCell> */}
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

interface EnhancedTableToolbarProps {
  numSelected: number;
  selectedData: any;
}

function EnhancedTableToolbar(props: EnhancedTableToolbarProps) {
  //****************** Alert Toast **********************/
  const [open, setOpen] = React.useState(false);
  const [alertType, setAlertType] = React.useState<AlertColor>("success"); //error, warning, info, success
  const [alertMessage, setAlertMessage] = React.useState("");
  const handleToastClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const { numSelected, selectedData } = props;
  const {
    isLoading,
    isError,
    message,
    sendRequest: seatStatusUpdate,
  } = useHttp();

  const [openState, setOpenState] = React.useState(false)
  const seatStatusUpdateResponse = (res: any) => {
    console.log(res);
    setOpen(true);
    setOpenState(true)
    if (res.error === false) {
      // setIsResetPasswordState(true);
      setAlertType("success");
      setAlertMessage(res.message);
    } else {
      setAlertType("error");
      setAlertMessage(res.message);
    }
  };

  const saveHandler = () => {
    console.log("save", selectedData);
    const test = seatStatusUpdate(
      {
        URL: "/api/seats/update",
        method: "POST",
        header: {
          "Content-Type": "application/json",
        },
        body: {
          data: selectedData,
          accountID: "RiTL8a7odR06wHE2YeoVa7TN0pV1wYZzWkRM5Kxm-lilrot7s",
        },
      },
      seatStatusUpdateResponse
    );
  };

  
  const refreshHandler =() =>{
    window.location.reload()
  }


  return (
    <>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleToastClose}>
        <Alert
          onClose={handleToastClose}
          severity={alertType}
          sx={{ width: "100%" }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>


      
<Dialog open={openState} >
        <DialogTitle sx={{ textAlign: "center" }}>
        {/* {isSubscriptionCancelled == false ? "Cancel subscription" : ""} */}
        </DialogTitle>
        <DialogContent>         
            <Grid sx={{ width: "100%", textAlign: "center" }}>
              <Box>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <LoadingButton
                    variant="text"
                    sx={{
                      mt: 3,
                      mb: 2,
                      width: "100px",

                      height: "100px",
                    }}
                  >
                    <CheckCircleOutlineIcon
                      sx={{ color: "#5ACE65", fontSize: "60px" }}
                    />
                  </LoadingButton>
                </Box>

                <Typography
                  component="h5"
                  variant="h5"
                  sx={{ fontSize: "30px" }}
                >
                  {"Changes are updated successfully"}
                </Typography>
                

                  <LoadingButton
                    type="submit"
                    variant="contained"
                    // loading={isLoading}
                    onClick={refreshHandler}
                    sx={{
                      mt: 3,
                      mb: 2,
                      width: "250px",
                      bgcolor: "#F47907",
                      fontSize: "11px",
                      "&.Mui-disabled": {
                        background: "#f6d9b9",
                      },
                      "&:hover": {
                        bgcolor: "#FF8D24",
                      },
                    }}
                  >
                    Refresh page
                  </LoadingButton>
              
              </Box>
            </Grid>
          
        </DialogContent>
      </Dialog>


      <Toolbar
        sx={{
          display: numSelected > 0 ? "flex" : "none",
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
          ...(numSelected > 0 && {
            bgcolor: (theme) =>
              alpha(
                theme.palette.primary.main,
                theme.palette.action.activatedOpacity
              ),
          }),
        }}
      >
        {numSelected > 0 ? (
          <Typography
            sx={{ flex: "1 1 100%" }}
            color="inherit"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected
          </Typography>
        ) : (
          <Typography
            sx={{ flex: "1 1 100%" }}
            variant="h6"
            id="tableTitle"
            component="div"
          >
            {""}
          </Typography>
        )}
        {numSelected > 0 ? (
          <Tooltip title="Save Changes">
            <LoadingButton
              type="submit"
              variant="contained"
              loading={isLoading}
              onClick={saveHandler}
              sx={{
                bgcolor: "inherit",
                color: "black",
                fontSize: "12px",
                "&:hover": {
                  bgcolor: "inherit",
                  color: "white",
                },
              }}
            >
              {/* <DeleteIcon /> */}
              <SaveIcon sx={{ color: "#F47907" }} />
            </LoadingButton>
          </Tooltip>
        ) : (
          <Tooltip title="Filter list">
            <IconButton>{/* <FilterListIcon /> */}</IconButton>
          </Tooltip>
        )}
      </Toolbar>
    </>
  );
}

const label = { inputProps: { "aria-label": "Size switch demo" } };

const Seats = () => {
  const seatsCxt = React.useContext(SeatsContext);

  // console.log("seatsData", seatsCxt.seats);

  const rows: Data[] = [];

  seatsCxt.seats.map((a: any, index: number) => {
    const seatformatdata = {
      //   SNo: ""+(index+1),
      UserID: a.userID.split("~")[1],
      UserDirectory: a.userID.split("~")[0], //.split("~")[1],
      Products: "App Extensions",
      AddedOn: date.format(new Date(a.createdAt), "DD-MMM-YY hh:mm A"),
      LastAccess: date.format(new Date(a.createdAt), "DD-MMM-YY hh:mm A"),
      Status: a.isActive === true ? 1 : 0,
    };

    rows.push(seatformatdata);
  });

  const [order, setOrder] = React.useState<Order>("asc");
  const [orderBy, setOrderBy] = React.useState<keyof Data>("UserID");
  const [selected, setSelected] = React.useState<readonly string[]>([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.UserID);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event: React.MouseEvent<unknown>, name: string) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected: readonly string[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name: string) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(rows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage]
  );

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <EnhancedTableToolbar
          numSelected={selected.length}
          selectedData={selected}
        />
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {visibleRows.map((row, index) => {
                const isItemSelected = isSelected(row.UserID);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    // onClick={(event) => handleClick(event, row.UserID)}
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.UserID}
                    selected={isItemSelected}
                    sx={{ cursor: "pointer" }}
                  >
                   
                    <TableCell
                      component="th"
                      id={labelId}
                      scope="row"
                      padding="normal"
                      align="left"
                    >
                      <Typography sx={{ color: "#F47907" }}>
                       {row.UserID}
                      </Typography>{" "}
                    </TableCell>
                    <TableCell align="left">{row.UserDirectory}</TableCell>
                    <TableCell align="left">
                      {/* {row.Products} */}
                      <Tooltip title="App Extensions">
                        <img
                          height={"25px"}
                          alt="App Extensions"
                          src="/assets/Elements/AppExtension.svg"
                        />
                      </Tooltip>
                      <Tooltip title="Custom Integration">
                        <img
                          height={"25px"}
                          alt="Custom Integration"
                          src="/assets/Elements/CustomIntegration.svg"
                          style={{ margin: "0 5px" }}
                        />
                      </Tooltip>
                      <Tooltip title="Code Management">
                        <img
                          height={"25px"}
                          alt="Code Management"
                          src="/assets/Elements/CodeManagement.svg"
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell align="left">{row.AddedOn}</TableCell>
                    <TableCell align="left">{row.LastAccess}</TableCell>
                    <TableCell align="left">
                      <Switch
                        disabled={seatsCxt.availableSeats <= 10 ? true : false}
                        // {...label}
                        // defaultChecked
                        // checked={true}
                        // color="warning"
                        defaultChecked={row.Status == 1 ? true : false}
                        size="small"
                        onClick={(event) =>
                          handleClick(
                            event,
                            row.UserDirectory + "~" + row.UserID
                          )
                        }
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          count={rows.length}
          component="div"
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
          labelRowsPerPage={<span>Rows:</span>}
          labelDisplayedRows={({ page }) => {
            return `Page: ${page}`;
          }}
          backIconButtonProps={{
            color: "secondary",
            // "&.Mui-disabled":{
            //   bgcolor: "red"
            // }
          }}
          nextIconButtonProps={{ color: "secondary" }}
          SelectProps={{
            inputProps: {
              "aria-label": "page number",
            },
          }}
          showFirstButton={true}
          showLastButton={true}
          //ActionsComponent={TablePaginationActions}
          //component={Box}
          //sx and classes prop discussed in styling section
        />
        {/* <TablePagination
          rowsPerPageOptions={[10, 20, 50]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            // "MuiIconButton": {
            //   color: "red",
            // },
          }}
        /> */}
      </Paper>
      {/* <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      /> */}
    </Box>
  );
};

export default Seats;
